import {
    ACTIVITY_FACE_MATCH_CAMERA_PAIR,
    ACTIVITY_FACE_MATCH_CONFIDENCE_BAND,
    ACTIVITY_FACE_MATCH_ERROR_TYPE,
    ACTIVITY_FACE_MATCH_INPUT_SOURCE,
    ACTIVITY_MAX_FACE_MATCH_ERROR_MESSAGE_LENGTH,
} from 'utils/activityTracking/constants';
import { FACE_MATCH_CAMERA_PAIR, FACE_MATCH_FAILURE, FACE_MATCH_IMAGE_SOURCE } from 'utils/faceMatchEnforcement';

/** Face match domain values to the `face_match.*` wire values (BEAST-13916). An unknown value maps to `null`. */

const CAMERA_PAIR_BY_DOMAIN = {
    [FACE_MATCH_CAMERA_PAIR.TRUCK]: ACTIVITY_FACE_MATCH_CAMERA_PAIR.TRUCK,
    [FACE_MATCH_CAMERA_PAIR.CAR]: ACTIVITY_FACE_MATCH_CAMERA_PAIR.CAR,
    [FACE_MATCH_CAMERA_PAIR.MIXED]: ACTIVITY_FACE_MATCH_CAMERA_PAIR.MIXED,
};

const INPUT_SOURCE_BY_DOMAIN = {
    [FACE_MATCH_IMAGE_SOURCE.LIVE_STREAMS]: ACTIVITY_FACE_MATCH_INPUT_SOURCE.LIVE_STREAMS,
    [FACE_MATCH_IMAGE_SOURCE.SELECTED_SNAPSHOTS]: ACTIVITY_FACE_MATCH_INPUT_SOURCE.SELECTED_SNAPSHOTS,
};

// The band is the colour the agent saw, so it follows the face match history's confidence levels.
const CONFIDENCE_BAND_BY_LEVEL = {
    high: ACTIVITY_FACE_MATCH_CONFIDENCE_BAND.GREEN,
    medium: ACTIVITY_FACE_MATCH_CONFIDENCE_BAND.YELLOW,
    low: ACTIVITY_FACE_MATCH_CONFIDENCE_BAND.RED,
};

// Only these failures have a type of their own; anything else the service or the SDK threw is an API failure.
const ERROR_TYPE_BY_FAILURE = {
    [FACE_MATCH_FAILURE.NO_FACE_DETECTED]: ACTIVITY_FACE_MATCH_ERROR_TYPE.FACE_NOT_DETECTED,
    [FACE_MATCH_FAILURE.IMAGE_TOO_LARGE]: ACTIVITY_FACE_MATCH_ERROR_TYPE.LOW_IMAGE_QUALITY,
    [FACE_MATCH_FAILURE.INVALID_IMAGE_FORMAT]: ACTIVITY_FACE_MATCH_ERROR_TYPE.LOW_IMAGE_QUALITY,
    [FACE_MATCH_FAILURE.TIMEOUT]: ACTIVITY_FACE_MATCH_ERROR_TYPE.TIMEOUT,
};

export const toActivityCameraPair = (cameraPair) => CAMERA_PAIR_BY_DOMAIN[cameraPair] ?? null;

export const toActivityFaceMatchInputSource = (imageSource) => INPUT_SOURCE_BY_DOMAIN[imageSource] ?? null;

export const toActivityConfidenceBand = (confidenceLevel) => CONFIDENCE_BAND_BY_LEVEL[confidenceLevel] ?? null;

export const toActivityFaceMatchErrorType = (failureCode) => ERROR_TYPE_BY_FAILURE[failureCode] ?? ACTIVITY_FACE_MATCH_ERROR_TYPE.API_FAILURE;

// Two decimals, as a string: the provider's raw similarity can run to 17 characters, past the backend's value cap.
export const toActivityConfidenceScore = (similarity) =>
    typeof similarity === 'number' && Number.isFinite(similarity) ? String(Math.round(similarity * 100) / 100) : null;

export function toActivityErrorMessage(message) {
    if (typeof message !== 'string') return null;
    const trimmed = message.trim();
    if (!trimmed) return null;
    return trimmed.length > ACTIVITY_MAX_FACE_MATCH_ERROR_MESSAGE_LENGTH ? trimmed.slice(0, ACTIVITY_MAX_FACE_MATCH_ERROR_MESSAGE_LENGTH) : trimmed;
}
